const en = {
  players: "Players",
  tournaments: "Tournaments",
  matches: "Matches",
  firstName: "First Name",
  lastName: "Last Name",
  nickname: "Nickname",
  elo: "Elo",
  tournamentName: "Tournament name",
  tournamentSystem: "Tournament type",
  addNewPlayer: "Add new player",
  editPlayer: "Edit player",
  optional: "optional",
  startingElo: "Initial Elo rating (player level)",
  beginner: "Beginner",
  intermediate: "Intermediate",
  advanced: "Advanced",
  expert: "Expert",
  createPlayer: "Add Player",
  listOfPlayers: "List of Players",
  listOfTournaments: "List of Tournaments",
  addNewTournament: "Create new Tournament",
  createTournament: "Create Tournament",
  tournamentSystem_SWISS: "Swiss system",
  tournamentSystem_GROUPS: "Group system",
  tournamentSystem_GROUPS_PLAYOFF: "Groups + Playoff",
  tournamentSystem_BLAST: "Blast",
  setsNeededToWin: "Sets needed to win",
  setsToWin: "Sets to win",
  ladderStatistics: "Ladder Statistics",
  totalTournaments: "Total Tournaments",
  totalMatches: "Total Matches",
  records: "Records",
  highestEloEver: "Highest Elo Ever",
  mostTournamentsWon: "Most Tournaments Won",
  mostTournamentsPlayed: "Most Tournaments Played",
  mostMatchesPlayed: "Most Matches Played",
  wins: "wins",
  setsPlayed: "sets played",
  pointsPlayed: "points played",
  ranking: "Ranking",
  tournamentState: "Tournament State",
  tournamentState_NOT_STARTED: "Setting up",
  tournamentState_IN_PROGRESS: "In progress",
  tournamentState_FINISHED: "Finished",
  tournamentState_CANCELED: "Canceled",
  search: "Search",
  player: "Player",
  seeding: "Seeding",
  saveSeeding: "Save Seeding",
  startTournament: "Start Tournament",
  matchesWon: "Games won",
  matchesLost: "Games lost",
  pointsWon: "Points won",
  pointsLost: "Points lost",
  setsWon: "Sets won",
  setsLost: "Sets lost",
  points: "Points",
  sets: "Sets",
  score: "Score",
  roundNumber: "Round {{roundNumber}}",
  group: "Group",
  groups: "Groups",
  groupTab: "Group {{groupNumber}}",
  setResult: "Set the result",
  playerWon: "{{player}} won",
  playerDefaultWin: "Default win - {{player}}",
  save: "Save",
  matchResult: "Match result",
  setNumber: "Set {{number}}",
  roundInProgress: " (In progress)",
  roundDurationRunning: "Round running:",
  roundDurationFinished: "Round took:",
  newRoundStartedTitle: "A new round has started!",
  newRoundStartedBody: "Round {{round}} has been announced.",
  goToNewRound: "Go to the new round",
  finishRound: "Finish Round",
  cancelRound: "Cancel Round",
  cancel: "Cancel",
  rounds: "Rounds",
  confirm: "Confirm",
  cancelRoundConfirmation: "Are you sure you want to cancel this round? This action cannot be undone.",
  finishTournament: "Finish Tournament",
  finishTournamentConfirmation: "Are you sure you want to finish the tournament? This action cannot be undone.",
  doubleElimination: "Double Elimination",
  finalPlacement: "Results",
  myMatches: "My matches",
  playerProfile: "Player profile",
  statistics: "Statistics",
  rank: "Rank",
  tournamentsPlayed: "Tournaments played",
  averagePercentile: "Ø Percentile",
  placement: "Placement",
  totalPlayers: "Players total",
  startingEloShort: "Initial rating",
  eloEvolution: "Elo rating evolution",
  login: "Log in",
  logout: "Log out",
  loginAsAdministrator: "Log in as Administrator",
  createAccount: "Create account",
  username: "Username",
  password: "Password",
  confirmPassword: "Confirm password",
  noTournamentsYet: "This player has no tournaments on their record yet.",
  noMatchesYet: "This player has no matches on their record yet.",
  achievements: "Awards",
  achievementTitle__GOLD: "Golden medal",
  achievementTitle__SILVER: "Silver medal",
  achievementTitle__BRONZE: "Bronze medal",
  achievementTitle__POTATO: "Potato medal",
  achievementTitle__HAT_TRICK: "Hat-Trick",
  achievementTitle__UNDEFEATED: "Undefeated",
  achievementTitle__UNSTOPPABLE: "Unstoppable",
  achievementTitle__DISHONORED: "Dishonored",
  achievementTitle__PLOT_TWIST: "Plot twist",
  achievementTitle__PROPHECY: "Prophecy",
  achievementTitle__HARDEST_PATH: "Hardest path",
  achievementTitle__NO_HURRY: "I'm gonna need a bigger towel",
  achievementTitle__TIME_IS_MONEY: "I'm in a hurry",
  achievementTitle__GET_YOUR_MONEYS_WORTH: "Getting my money's worth",
  achievementTitle__ALL_THINGS_MUST_BE_BALANCED: "Perfectly balanced",
  achievementTitle__PEAK_PERFORMANCE: "Peak performance",
  achievementTitle__CONSISTENCY_IS_KEY: "Consistency is the key to success",
  achievementTitle__BACK_FROM_THE_DEAD: "Back from the dead",
  achievementDescription__GOLD: "Finish in 1st place",
  achievementDescription__SILVER: "Finish in 2nd place",
  achievementDescription__BRONZE: "Finish in 3rd place",
  achievementDescription__POTATO: "Finish in 4th place",
  achievementDescription__HAT_TRICK: "Win three matches in a row (within one tournament)",
  achievementDescription__UNDEFEATED: "Win every match",
  achievementDescription__UNSTOPPABLE: "Win every set",
  achievementDescription__DISHONORED: "Win a set without losing a single point",
  achievementDescription__PLOT_TWIST: "Reach the highest difference between the seeded and the final position",
  achievementDescription__PROPHECY: "Finish with the final position equal to the seeded position",
  achievementDescription__HARDEST_PATH: "Finish with the highest Buchholz score",
  achievementDescription__NO_HURRY: "Finish with the highest number of points played",
  achievementDescription__TIME_IS_MONEY: "Finish with the lowest number of points played",
  achievementDescription__GET_YOUR_MONEYS_WORTH: "Finish with the highest number of sets played",
  achievementDescription__ALL_THINGS_MUST_BE_BALANCED: "Finish with a zero difference between points won and points lost",
  achievementDescription__PEAK_PERFORMANCE: "Reach the highest match rating in the tournament",
  achievementDescription__CONSISTENCY_IS_KEY: "Reach the highest tournament rating",
  achievementDescription__BACK_FROM_THE_DEAD: "Turn a match around after losing 0:2",
  achievementTitle__FLASH: "Flash",
  achievementDescription__FLASH: "You reported your match result faster than anyone else",
  achievementTitle__SLOWPOKE: "Slowpoke",
  achievementDescription__SLOWPOKE: "Your match result took longer to come in than anyone else's",
  date: "Date",
  tournamentDate: "Tournament date",
  sortByElo: "Sort by Elo",
  nationality: "Nationality",
  awardedAchievements: "Achievements awarded",
  welcomeHeaderRaw: "Welcome to the Ping-Pong Playground!",
  welcomeHeaderRawMobile: "Welcome to the\nPing-Pong\nplayground!",
  welcomeHeader: "Welcome to the <span class='loss'>P</span>ing-<span class='loss'>P</span>ong Playground!",
  welcomeText1: "<b class='win'>Hravé Turnaje</b> let you track your stats, earn awards for your performances, and compare your rating with your friends. <a href=\"https://stolnitenisbrno.isportsystem.cz/\">Sign up for a tournament</a> and claim your place in the hall of fame!",
  welcomeText2: "This site was created with love for ping-pong and Hravý Bar by <b>Seboš</b>. Huge thanks to my friend <b>beavis</b> for hosting the app and endlessly motivating me to keep building it.",
  welcomeText3: "This is an early version of the website.\n" +
    "There may still be some bugs or missing features. I’d really appreciate any feedback, suggestions, or ideas to help improve it!",
  myreg: "Myreg<br />is<br />a<br />DUMBASS<br />🤐",
  notFound: "This is not the page you're looking for. :(",
  pointAbbreviation: "p",
  opponents: "opp.",
  editTournament: "Edit Tournament",
  news: "News",
  buchholzScore: "(Bch) - Buchholz score",
  buchholzScoreDescription: "Buchholz score is the sum of a player's opponents' points – it reflects the strength of their opposition.",
  plannedChanges: "Planned changes",
  unreleasedChanges: "Unreleased changes",
  beginnerLadder: "Beginners",
  intermediateLadder: "Intermediate",
  advancedLadder: "Advanced",
  ladders: "Ladders",
  officialLadders: "Official ladders",
  unofficialLadders: "Custom ladders",
  createLadder: "Create ladder",
  ladderNameCs: "Name (Czech)",
  ladderNameEn: "Name (English)",
  newLadderIntro: "A ladder lets you run tournaments with their own ELO and achievements, kept separate from other ladders. You can also configure which other users are allowed to create and manage tournaments in it.",
  newLadderNoLadderHint: "If you just want to run a one-off tournament and don't care about a ladder, you don't have to create one — pick “No ladder” when creating the tournament.",
  basicInformation: "Basic info",
  showAdvancedSettings: "Show advanced settings",
  hideAdvancedSettings: "Hide advanced settings",
  advancedSettings: "Advanced settings",
  calculateEloHint: "Every match updates players' ELO in this ladder.",
  discountCloseLossHint: "Losing a close match costs less ELO.",
  calculateRatingHint: "Each match gives players a performance score (0–2); the tournament rating is their average across all matches.",
  awardAchievementsHint: "Tournaments in this ladder grant achievements (e.g. Gold, Silver).",
  calculateElo: "Calculate player ELO",
  discountCloseLoss: "Deduct less ELO for close losses",
  calculateRating: "Calculate performance rating",
  awardAchievements: "Grant achievements",
  ladderOwner: "Owner",
  ladderOrganizers: "Organizers",
  transferOwnership: "Transfer ownership",
  addOrganizer: "Add organizer",
  removeOrganizer: "Remove organizer",
  removeOrganizerConfirmation: "Do you really want to remove organizer {{username}}?",
  transferOwnershipConfirmation: "Do you really want to transfer ladder ownership to {{username}}? Only the new owner or an admin can undo this.",
  ladderSettings: "Ladder settings",
  unofficialLaddersIntro: "Press the “+” button in the top-right corner to create your own ladder.",
  noUnofficialLadders: "No custom ladders yet.",
  addPlayerAdminHint: "The new player is added to the central roster.",
  close: "Close",
  notAuthorized: "You are not allowed to change these settings.",
  noLadder: "No ladder",
  playerLadders: "Player standings",
  tournamentsColumn: "Tournaments",
  playersColumn: "Players",
  organizer: "Tournament organizer",
  ladder: "Ladder",
  administration: "Super awesome administration page",
  recalculateElo: "Recalculate elo",
  outOf: "out of",
  homepageTournaments: "Tournaments",
  homepagePoints: "Points",
  homepageMatches: "Matches",
  homepagePlayers: "Players",
  homepageAchievements: "Achievements",
  numberOfGroups: "Number of groups",
  groupShort: "G",
  info: "Info",
  information: "Information",
  averageElo: "Average Elo rating",
  passwordDoesNotMatch: "Passwords do not match",
  usernameAlreadyExists: "This username already exists",
  createAccountInfo: "After creating an account, please ask the tournament organizer to link it with your player profile. This will allow you to enter match results independently.",
  somethingWentWrong: "Something went wrong, please contact an administrator to resolve this issue.",
  userAccount: "User Account",
  noUserAccount: "Player does not have an account yet",
  about: "About the app",
  usernameOnlyLettersNumbers: "Username can only contain letters and numbers",
  scoretable: "Score table",
  round: "Round",
  wrongPassword: "Wrong password, please try again",
  achievementsAndStats: "Stats & awards",
  averagePercentileHeader: "Average Percentile",
  averagePercentileDescription: "Calculated as the arithmetic mean of percentiles from final standings in individual tournaments. If a player finishes first once and last once, their percentiles will be 100 and 0, and their average will be 50.",
  chat: "Chat",
  failedToLoadMessages: "Failed to load messages",
  failedToSendMessage: "Failed to send message",
  failedToReactToMessage: "Failed to react to message",
  react: "React",
  addReaction: "Add reaction",
  removeReaction: "Remove reaction",
  reply: "Reply",
  replyingTo: "Replying to",
  edit: "Edit",
  edited: "edited",
  editedAt: "Edited at {{time}}",
  pin: "Pin",
  unpin: "Unpin",
  pinned: "Pinned",
  failedToEditMessage: "Failed to edit message",
  failedToPinMessage: "Failed to pin message",
  someoneIsTyping: "{{name}} is typing…",
  twoAreTyping: "{{first}} and {{second}} are typing…",
  severalAreTyping: "{{count}} people are typing…",
  failedToDeleteMessage: "Failed to delete message",
  loadMore: "Load more",
  send: "Send",
  typeMessage: "Type a message...",
  delete: "Delete",
  reload: "Reload",
  loading: "Loading...",
  cannotChatInfo: "To be able to send messages, you need to have an account created and linked to your player profile.",
  deleteMessage: "Delete message",
  deleteMessageConfirmation: "Are you sure you want to delete this message? This action cannot be undone.",
  changePassword: "Change password",
  resetPassword: "Reset password",
  resetPasswordConfirmation: "Are you sure you want to reset the password? This action cannot be undone.",
  currentPassword: "Current password",
  resetPasswordOf: "Change password for {{username}}",
  iUnderstand: "I understand",
  wannaChat: "Before you start typing…",
  chatRules1: "The chat is public - anything you write can be read by anyone. So don't get too rowdy in here. :D",
  unreadChatMessages: "New chat messages",
  unreadChatMention: "You were mentioned in chat",
  unreadNews: "New news entry",
  averageMatchDuration: "Average match duration",
  emoji: "Emoji",
  gif: "GIF",
  searchGifs: "Search GIFs…",
  groupOverview: "Přehled skupin (round {{round}})",
  hallOfFame: "Hall of Fame",
  legends: "Legends",
  recordMatches: "Record matches",
  record_HIGHEST_ELO: "Highest Elo reached",
  record_LONGEST_WIN_STREAK: "Longest win streak",
  record_MOST_TOURNAMENTS_WON: "Most tournaments won",
  record_MOST_TOP3_PLACEMENTS: "Most top 3 placements",
  record_MOST_TOURNAMENTS_PLAYED: "Most tournaments played",
  record_MOST_MATCHES_WON: "Most matches won",
  record_SHORTEST_MATCH: "Shortest match",
  record_SHORTEST_MATCH_BO3: "Shortest match (best of 3)",
  record_SHORTEST_MATCH_BO5: "Shortest match (best of 5)",
  record_MOST_BALANCED: "Closest match",
  record_MOST_BALANCED_BO3: "Closest match (best of 3)",
  record_MOST_BALANCED_BO5: "Closest match (best of 5)",
  record_BIGGEST_ELO_SHIFT: "Biggest Elo shift",
  record_BIGGEST_ELO_HAUL: "Biggest Elo haul",
  record_HIGHEST_ELO_MATCH: "Highest total Elo match",
  record_LONGEST_MATCH: "Longest match",
  record_LONGEST_MATCH_BO3: "Longest match (best of 3)",
  record_LONGEST_MATCH_BO5: "Longest match (best of 5)",
  record_LONGEST_SET: "Longest set",
  record_BIGGEST_COMEBACK: "Biggest comeback",
  record_BIGGEST_COMEBACK_BO3: "Biggest comeback (best of 3)",
  record_BIGGEST_COMEBACK_BO5: "Biggest comeback (best of 5)",
  record_MOST_ACHIEVEMENTS: "Most achievements awarded",
  record_HIGHEST_TOURNAMENT_RATING: "Highest tournament rating",
  record_HIGHEST_MATCH_RATING: "Highest performance rating",
  topMatches: "Top Matches",
  currentRound: "Current round",
  otherRounds: "Other rounds",
  myMatches__start: "Tournament start – seeded {{seeding}}",
  myMatches__swissRound: "Round {{round}} finished - placed {{placement}}",
  myMatches__groupRound: "First round group finished - placed {{placement}}",
  myMatches__playoffRound: "Playoff round {{round}} finished",
  myMatches__end: "Tournament concluded - final placement: {{placement}}.",
  myMatches__end_wellDone: "Tournament concluded - final placement: {{placement}}. Well done!",
  actions: "Actions",
  matchDetail: "Match Detail",
  headToHead: "Head to Head",
  noHeadToHeadHistory: "No previous matches between these players.",
  detail: "Detail",
  winProbability: "Win Probability",
  currentForm: "Current Form",
  winStreak: "Win Streak",
  matchesPlayed: "Matches Played",
  avgRating: "Avg. Rating",
  lastVictory: "Last Victory",
  eloGained: "Elo Gained",
  previousMatches: "Previous Matches",
  themeLight: "Light mode",
  themeDark: "Dark mode",
  themeProjector: "Projector mode",
  all: "All",
  playoff: "Playoff",
  playoffBracket: "Playoff Bracket",
  winnersBracket: "Winners Bracket",
  losersBracket: "Losers Bracket",
  grandFinal: "Grand Final",
  grandFinalMatch: "Grand Final",
  bracketReset: "Bracket Reset",
  thirdPlaceMatch: "Third Place Match",
  final: "Final",
  bench: "Bench",
  moveToBench: "Move to bench",
  returnFromBench: "Return from bench",
  queue: "Queue",
  stopGeneration: "Stop",
  resumeGeneration: "Start",
  generationStopped: "Generation stopped",
  generationRunning: "Generation running",
  onBench: "On bench",

  accessDenied: "Access denied",

  // Awards ceremony tab
  awardsCeremony: "Awards Ceremony",
  awardsIntro__title: "Awards Ceremony",
  awardsIntro__hint: "Press right arrow to start from last place →",
  previousPlayer: "Previous player",
  nextPlayer: "Next player",
  noFinalPlacements: "No final placements to show",
  noAchievementsThisTournament: "No achievements earned in this tournament.",

  // Awards ceremony - fun facts (priority order, first applicable wins)
  // Firsts (cross-tournament)
  funFact__firstEver: "This was his very first tournament - welcome aboard!",
  funFact__firstTop3InLadder: "His first ever podium finish in this ladder!",
  funFact__firstWinInLadder: "His very first tournament win in this ladder - congratulations!",
  funFact__firstInLadder: "His debut in this ladder!",
  // Personal records (cross-tournament)
  funFact__newBestPlacement: "His best ever placement in this ladder - climbing the ranks!",
  funFact__newEloHigh: "Walks away with a brand new all-time Elo high in this ladder!",
  funFact__tiedBestPlacement: "Tied his best ever placement in this ladder!",
  // Comeback / veteran (cross-tournament)
  funFact__longReturn: "Back after {{months}} months off - the comeback is real!",
  funFact__ladderMilestone: "His {{count}}th tournament in this ladder - practically a resident!",
  funFact__careerMilestone: "His {{count}}th tournament overall - a true ping-pong veteran!",
  // Tournament moments (within-tournament)
  funFact__topMatchFeatured: "One of his matches made the tournament's top matches - entertainer of the day!",
  funFact__beatTheWinner: "Beat the eventual tournament champion - moment for the memory book!",
  funFact__topSeed: "Entered the tournament as the top seed - the favorite!",
  funFact__beatTopSeed: "Beat the highest-seeded player of the tournament - no respect!",
  funFact__longerWinStreak: "Won {{count}} matches in a row - quite a streak!",
  funFact__allMatchesDecisive: "Every single one of his matches went to a deciding set - drama on tap!",
  funFact__closestMatch: "Played the tournament's closest match - no set was decided by more than {{points}} points!",
  funFact__highestEloMatch: "Played the match with the highest combined Elo in the tournament - top tier!",
  funFact__mostBalancedMatch: "Played the most evenly-matched match by Elo - two peas in a pod!",
  funFact__biggestSetMarginWin: "Won the most one-sided set of the tournament ({{margin}}-point margin)!",
  funFact__allOpponentsHigherElo: "Every single opponent he faced had higher Elo - thrown in the deep end!",
  funFact__rematchedOpponent: "Faced the same opponent multiple times - rivalry brewing!",
  funFact__mostLikedMatch: "His match got the most love of the tournament - entertainer of the day!",
  funFact__firstMatchOfTournament: "Opened the tournament with his match - no time to warm up!",
  funFact__lastMatchOfTournament: "His match closed out the tournament - grand finale!",
  funFact__topEloGain: "Walked away with the biggest Elo gain (+{{elo}}) - a career boost!",
  funFact__upset: "Took down a player with {{diff}} higher Elo - beautiful upset!",
  funFact__comebackKing: "Turned the match around {{count}} times after losing the first set - nerves of steel!",
  funFact__longestMatch: "Played the longest match of the tournament - a {{points}}-point marathon!",
  funFact__longestSet: "Played the longest set of the tournament ({{points}} points) - nobody wanted to give in!",
  funFact__decisiveSetHero: "Took {{count}} matches all the way to a deciding set and pulled them off!",
  funFact__closeSetMaster: "Won {{count}} sets by 2 points or less - no boring rallies here!",
  funFact__longSets: "Played {{count}} long sets over 20 points - drama on drama!",
  funFact__cleanWins: "All {{count}} of his wins came in straight sets - efficient!",
  // Neutral fallbacks - varied so 25 players don't see the same line
  funFact__generic1: "Went home with {{sets}} sets won and {{points}} points in the bag.",
  funFact__generic2: "Tally: {{matches}} matches and {{sets}} sets won - a solid day.",
  funFact__generic3: "Made {{points}} balls work for him today - nobody's taking them back.",

  // Zákulisí (Backstage)
  zakulisi: "Backstage",
  zakulisi__players: "Players",
  zakulisi__users: "Accounts",
  zakulisi__tournaments: "Tournaments",
  zakulisi__matches: "Matches",
  zakulisi__searchPlayer: "Search player by name…",
  zakulisi__searchUser: "Search account by username…",
  zakulisi__searchTournament: "Search tournament by name…",
  zakulisi__searchPlayerForMatches: "Find a player whose matches you want to edit…",
  zakulisi__viewMatches: "Matches",
  zakulisi__back: "Back",
  zakulisi__edit: "Edit",
  zakulisi__editing: "Editing",
  zakulisi__type: "Type",
  zakulisi__sets: "Sets",
  zakulisi__hidden: "Hidden tournament",
  zakulisi__hiddenHelp: "Hidden tournaments are not shown in public listings.",
  zakulisi__state: "State",
  zakulisi__date: "Date",
  zakulisi__role: "Role",
  zakulisi__playerId: "Player ID",
  zakulisi__userId: "Account ID",
  zakulisi__linkUser: "Link account",
  zakulisi__linkUserFor: "Link account for",
  zakulisi__link: "Link",
  zakulisi__unlink: "Unlink",
  zakulisi__promoteToAdmin: "Promote to ADMIN",
  zakulisi__demoteToUser: "Demote to USER",
  zakulisi__superadminProtected: "Protected",

  // Audit log
  auditLog: "Audit log",
  administrationActions: "Actions",
  auditLog__allActions: "All actions",
  auditLog__usernameFilter: "Username",
  auditLog__from: "From",
  auditLog__to: "To",
  auditLog__when: "When",
  auditLog__user: "User",
  auditLog__action: "Action",
  auditLog__entity: "Entity",
  auditLog__details: "Details",
  auditLog__empty: "No entries",
  auditAction__USER_REGISTERED: "User registered",
  auditAction__USER_PASSWORD_CHANGED: "Password changed",
  auditAction__USER_PASSWORD_RESET: "Password reset",
  auditAction__USER_ROLE_CHANGED: "Role changed",
  auditAction__PLAYER_CREATED: "Player created",
  auditAction__PLAYER_UPDATED: "Player updated",
  auditAction__PLAYER_USER_LINK_CHANGED: "Player↔account link changed",
  auditAction__TOURNAMENT_CREATED: "Tournament created",
  auditAction__TOURNAMENT_UPDATED: "Tournament updated",
  auditAction__TOURNAMENT_PLAYERS_SET: "Tournament players set",
  auditAction__TOURNAMENT_STARTED: "Tournament started",
  auditAction__TOURNAMENT_FINISHED: "Tournament finished",
  auditAction__TOURNAMENT_DOUBLE_ELIMINATION_TOGGLED: "Double elimination toggled",
  auditAction__TOURNAMENT_BLAST_GENERATION_TOGGLED: "Blast generation toggled",
  auditAction__BLAST_PLAYER_BENCHED: "Blast - player benched",
  auditAction__BLAST_PLAYER_RETURNED: "Blast - player returned",
  auditAction__ROUND_FINISHED: "Round finished",
  auditAction__ROUND_CANCELED: "Round canceled",
  auditAction__MATCH_RESULT_SET: "Match result set",
  auditAction__CHAT_MESSAGE_DELETED: "Chat message deleted",
  auditAction__STICKY_NOTE_DELETED: "Board note deleted",
  auditAction__ELO_RECALCULATED: "Elo recalculated",

  // Bulletin board
  board: "Board",
  boardLoginRequired: "The board is for signed-in users only. Log in and pin your note!",
  boardLinkRequired: "The board is only available to users with a linked player profile. Ask an admin to link your account.",
  boardNewNote: "New note",
  boardEmpty: "The board is empty so far — pin the first note!",
  boardPlaceHint: "Tap where you want to pin your note",
  boardRotate: "Rotate note",
  boardRotateHint: "Drag across the board to spin the note around its pin, then confirm.",
  boardZoomIn: "Zoom in",
  boardZoomOut: "Zoom out",
  boardZoomFit: "Fit whole board",
  boardMoveOwnHint: "Tip: drag to pan the board, zoom with the mouse wheel or two fingers. You can drag your own notes around and rotate them with the ↻ button.",
  boardDeleteNoteTitle: "Delete note?",
  boardDeleteNoteMessage: "The note will be permanently removed from the board.",
  boardCreateFailed: "Failed to pin the note. Please try again.",
  boardImageTooLarge: "The drawing is too large, try simplifying it a bit.",
  boardEditorTitle: "New note",
  boardTool_pen: "Pencil",
  boardTool_marker: "Marker",
  boardTool_rainbow: "Rainbow",
  boardTool_eraser: "Eraser",
  boardTool_text: "Text",
  boardTool_emoji: "Stickers",
  boardPenColor: "Color",
  boardStrokeWidth: "Width",
  boardPaperColor: "Paper",
  boardPinColor: "Pin",
  boardFont: "Font",
  boardUndo: "Undo",
  boardRedo: "Redo",
  boardClear: "Clear",
  boardPin: "Pin to the board",
  boardTextPlaceholder: "Type text…",
  boardPollToggle: "Voting note",
  boardPollHint: "The note gets a voting strip below it — others can add their vote ✅ or ❌. Everyone has one vote and can change it anytime.",
  boardPollYes: "Vote YES",
  boardPollNo: "Vote NO",
  boardPollRetract: "Retract vote",
  boardTextHint: "Tap the note where you want to write. A text box appears — type your text and confirm with Enter or the green checkmark.",
  boardEmojiHint: "Pick a sticker and tap the note where you want to stamp it. Change its size with the Width slider.",
};

export default en;
